import en from './locales/en';
import id from './locales/id';

export const messages = {
  en,
  id,
} as const;

export const defaultLocale = 'en' as const;
export const locales = ['en', 'id'] as const;
export type Locale = typeof locales[number];

// Export types
export type MessageStructure = typeof en;
export type MessageKeys = keyof MessageStructure;

// Helper untuk type-safe key access
export type TranslationKeys = {
  [K in keyof MessageStructure]: {
    [P in keyof MessageStructure[K]]: `${K & string}.${P & string}`;
  }[keyof MessageStructure[K]];
}[keyof MessageStructure];